<template>
  <v-card>
    <v-form @submit.prevent="prevent" v-model="valid" autocomplete="off">
      <v-card-title class="text-h5"
        ><span v-if="!readonly">{{ Create ? 'Create' : 'Edit' }}</span> {{ $t('MOC_Type') }}</v-card-title
      >
      <v-card-text>
        <v-text-field
          :readonly="readonly"
          :rules="mocTypeNameRules"
          label="Name"
          required
          variant="underlined"
          v-model="mocType.value"
          auto-grow
        ></v-text-field>
        <!--<v-text-field
          v-for="lang in languages"
          v-bind:key="lang.name"
          required
          v-model="mocType.translation[lang.value]"
          :label="lang.name"
          auto-grow
          rows="1"
          :min="minimumTranslationLength"
          :max="maximumTranslationLength"
          :rules="TranslationTypeRules"
         
        ></v-text-field>-->
      </v-card-text>
      <v-card-actions>
        <v-switch :readonly="readonly" v-model="mocType.enabled" color="black" :label="mocType.enabled ? 'Enabled' : 'Disabled'"></v-switch>
        <v-spacer></v-spacer>
        <v-btn v-if="!readonly" :disabled="!valid" color="success" @click="create">{{ Create ? 'Add' : 'Update' }}</v-btn>
        <v-btn @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  name: 'AddOrUpdateMOCType',
  data: () => ({
    minimumNameLength: 0,
    maximumNameLength: 120,
    minimumTranslationLength: 0,
    maximumTranslationLength: 300,
    valid: false
  }),
  methods: {
    prevent() {
      return true
    },
    create() {
      this.$emit('submit', this.mocType)
    },
    closeDialog() {
      this.$emit('close')
    }
  },
  computed: {
    mocTypeNameRules: {
      get: function() {
        return [
          v => !!v || 'Name is required',
          v => (v && v.trim().length > this.minimumNameLength) || `Minimum length is ${this.minimumNameLength}`,
          v => (v && v.trim().length < this.maximumNameLength) || `Maximum length is ${this.maximumNameLength}`,
          v =>
            this.ExistingTypes.findIndex(
              x => x.value.trim().toLowerCase() === v.trim().toLowerCase() && x.clientID !== this.mocType.clientID
            ) < 0 || 'Name already exists!'
        ]
      }
    } /*,
    TranslationTypeRules: {
      get: function() {
        return [
          v => !!v || 'Translation is required',
          v =>
            (v && v.trim().length >= this.minimumTranslationLength) ||
            `Minimum length is ${this.minimumTranslationLength}`,
          v =>
            (v && v.trim().length < this.maximumTranslationLength) ||
            `Maximum length is ${this.maximumTranslationLength}`
        ]
      }
    }*/
  },
  props: {
    mocType: Object,
    languages: Array,
    Create: Boolean,
    ExistingTypes: Array,
    readonly: Boolean
  }
}
</script>
